// import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import AppRoutes from "./app/router/Routes";
import { I18nProvider, LayoutSplashScreen, ThemeProvider } from "./infofleet";
import { HashRouter } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from "react";

export default function App({ store, persistor, basename }) {
  const [googleReady, setGoogleReady] = useState(false);

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyDkMms3OhCKPd6Vbl78-n4235HrFvWfaeA&libraries=places";
    script.async = true;
    script.defer = true;

    script.onload = () => {
      setGoogleReady(true);
      console.log("Google Maps script loaded");
    };

    script.onerror = () => {
      console.error("Failed to load Google Maps script");
    };

    document.body.appendChild(script);
  }, []);

  if (!googleReady) {
    return <LayoutSplashScreen />;
  }

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={<LayoutSplashScreen />}>
        <React.Suspense fallback={<LayoutSplashScreen />}>
          <HashRouter>
            <ThemeProvider>
              <I18nProvider>
                <AppRoutes />
              </I18nProvider>
            </ThemeProvider>
          </HashRouter>
        </React.Suspense>
      </PersistGate>
    </Provider>
  );
}
